import { render } from "./edit-provident-fund.vue?vue&type=template&id=5a7c2a58"
import script from "./edit-provident-fund.vue?vue&type=script&lang=js"
export * from "./edit-provident-fund.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__